import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const hotTags = ['出轨', '税务', '假唱', '塌房', '整容', '选秀造假', '洗钱', '抄袭', '学历造假'];
  const topArticle = articles.find((a) => a.isHot && a.isExclusive) || articles[0];

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20city%20nightscape%20with%20neon%20lights%20and%20mysterious%20atmosphere%2C%20cinematic%20red%20and%20amber%20tones%2C%20abstract%20urban%20entertainment%20scene%2C%20editorial%20photography%20style&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="51黑料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 md:pt-32 pb-16 md:pb-20 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-sm font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
            实时更新中 · 今日已更新 12 条
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-black text-foreground-50 leading-tight mb-4">
            51黑料网
            <span className="block text-xl sm:text-2xl md:text-3xl font-bold text-foreground-300 mt-2">
              吃瓜不打烊，猛料实时追
            </span>
          </h1>

          <p className="text-base md:text-lg text-foreground-400 max-w-2xl mx-auto mb-8 leading-relaxed">
            整合51黑料吃瓜网在线观看入口、每日黑料大赛与明星塌房现场爆料。全网独家猛料不打烊，满足吃瓜用户一站式浏览需求。
          </p>

          {/* Search bar */}
          <div className="max-w-xl mx-auto mb-8">
            <div className="flex items-center bg-background-800/80 backdrop-blur-sm rounded-full border border-background-700/50 px-4 py-3 md:px-5 md:py-3.5">
              <div className="w-5 h-5 flex items-center justify-center text-foreground-500 mr-3">
                <i className="ri-search-line" />
              </div>
              <input
                type="text"
                placeholder="搜索明星、事件、爆料关键词..."
                className="flex-1 bg-transparent text-sm md:text-base text-foreground-200 placeholder-foreground-600 outline-none"
                readOnly
              />
              <button className="px-4 py-1.5 md:px-5 md:py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                搜索
              </button>
            </div>
          </div>

          {/* Hot tags */}
          <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
            <span className="text-sm text-foreground-500">热门：</span>
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/category/daily-gossip`}
                className="px-3 py-1 rounded-full bg-background-800/60 border border-background-700/30 text-xs md:text-sm text-foreground-400 hover:text-primary-300 hover:border-primary-500/30 transition-colors whitespace-nowrap"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        {/* Featured article card */}
        <div className="max-w-3xl mx-auto mt-10 md:mt-14">
          <Link
            to={`/article/${topArticle.id}`}
            className="group flex flex-col md:flex-row items-start gap-4 md:gap-5 bg-background-900/80 backdrop-blur-sm rounded-xl border border-background-800/50 p-4 md:p-5 hover:border-primary-500/30 transition-all"
          >
            <div className="w-full md:w-48 h-32 md:h-28 rounded-lg overflow-hidden shrink-0">
              <img
                src={topArticle.image}
                alt={topArticle.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-1 text-left">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded bg-primary-500/20 text-primary-300 text-xs font-semibold">
                  独家
                </span>
                <span className="px-2 py-0.5 rounded bg-accent-500/20 text-accent-300 text-xs font-semibold">
                  爆
                </span>
              </div>
              <h2 className="text-sm md:text-base font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2">
                {topArticle.title}
              </h2>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-1">
                {topArticle.summary}
              </p>
              <div className="flex items-center gap-3 mt-2 text-xs text-foreground-600">
                <span>{topArticle.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {(topArticle.views / 10000).toFixed(1)}万
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}